import { cn } from "../foundations/cn.js";
import type { RarityTier } from "./rarity.js";
import { tierAtLeast } from "./rarityLook.js";

export interface RarityNameProps {
  name: string;
  tier: RarityTier;
  /** Its holder is awake (`useRarityWake`): only then does a Legendary or Chase name glint. */
  active: boolean;
  /** The name's type and layout; the glint takes the text's own color. */
  className?: string;
}

/**
 * An item's name wearing its rarity: from Legendary a soft silver glint passes through its
 * letters while its holder is awake. The glint repaints every frame, so at rest it is paused and
 * costs nothing; reduced motion keeps it still. Below Legendary it is the name alone.
 */
export function RarityName({ name, tier, active, className }: RarityNameProps) {
  const glint = tierAtLeast(tier, "legendary");
  return (
    <span
      data-text={glint ? name : undefined}
      data-paused={(glint && !active) || undefined}
      className={cn(className, glint && "legendary-shimmer")}
    >
      {name}
    </span>
  );
}
